export const crumbs = state => {
  return state.crumbs
}

export const isLoading = state => {
  return state.isLoading
}



// WEBPACK FOOTER //
// ./src/store/getters.js